module.exports = __webpack_public_path__ + "static/media/user-icon.621f0df9.svg";